if (document.querySelector('.post_type_button')) {
    document.querySelector('.post_type_button').addEventListener('click', () => {
        document.querySelector('.post_type_items').classList.toggle('expanded')
        document.querySelector('.post_type_button').classList.toggle('expanded')
    })

    document.addEventListener('click', function(event) {
        const dropdownButton = document.querySelector('.post_type_button')
    
        var isClickInside = dropdownButton.contains(event.target);
    
    
        if (!isClickInside && document.querySelector('.post_type_items').classList.contains('expanded')) {
            document.querySelector('.post_type_items').classList.remove('expanded')
            document.querySelector('.post_type_button').classList.remove('expanded')
        }
    });
}